<template>
    <a :href="`https://movix.brightfish.be/movies/${id}/edit`"
       target="_blank"
       rel="noopener">{{ title || id }}</a>
</template>
<script>
export default {
    props: [
        'id', 'title'
    ]
}
</script>
